export const WHATSAPP_NUMBER = '2347049891302'
export const CONTACT_EMAIL = 'betterwebsitecoofficial@gmail.com'
export const TIKTOK_URL = 'https://www.tiktok.com/@highfunctioningzone'
// Primary conversion destination for every "Book a Free Strategy Call" CTA
// site-wide. Plain direct link (opens in a new tab), not Calendly's embed/
// popup widget script — keeps the site from loading an extra third-party JS
// library just to open a scheduler, consistent with the rest of the site's
// "no unnecessary tracking/scripts" approach.
export const CALENDLY_URL = 'https://calendly.com/betterwebsiteco/letscreate'

export function buildWhatsAppLink(tierName) {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`
  const text = tierName
    ? `Hi! I'm interested in the ${tierName} plan from Better Website Co.`
    : `Hi! I'd like to talk to Better Website Co. about a new website.`
  return `${base}?text=${encodeURIComponent(text)}`
}

// Referral submissions go through WhatsApp too — no form backend yet, so this
// pre-fills the fields needed to track a referral manually (see Partners.jsx
// / data/partners.js: doc calls for manual tracking until volume justifies
// a dashboard).
export function buildReferralWhatsAppLink() {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`
  const text = `Hi! I'd like to refer a business to Better Website Co.\n\nMy name:\nBusiness I'm referring:\nContact for that business:\nWhat they need (website type, if known):`
  return `${base}?text=${encodeURIComponent(text)}`
}

// Academy waitlist — same reasoning as the referral link above: no form
// backend for this yet either, so WhatsApp carries it until real demand
// justifies a proper signup flow.
export function buildAcademyWhatsAppLink(programme) {
  const base = `https://wa.me/${WHATSAPP_NUMBER}`
  const text = programme
    ? `Hi! I'd like to join the waitlist for ${programme} (AI Business Academy).`
    : `Hi! I'd like to know more about the AI Business Academy.`
  return `${base}?text=${encodeURIComponent(text)}`
}
